// Libs
import React from 'react'
import { Bell, Shuffle } from 'react-feather'

// CSS
import "./styles.scss"

const HeaderPopUp = (props) => {
  const { visible, icon, width, title, notifications, toggleVisible, children } = props

  return (
    <div className="header-pop-up">
      <div className="header-pop-up__button" onClick={toggleVisible}>
        {icon === "swap" && <Shuffle size="20" />}
        {icon === "notifications" && <Bell size="20" />}
        {notifications && notifications.length > 0 && (
          <div className="header-pop-up__alert" />
        )}
      </div>
      <div style={{ width: `${width}px` }} className={visible ?
        "header-pop-up__wrapper header-pop-up__wrapper--visible" :
        "header-pop-up__wrapper"}>
        <p className="header-pop-up__title">{title}</p>
        <div className="header-pop-up__scrollable">
          {children}
        </div>
      </div>
    </div>
  )
}

export default HeaderPopUp
